import React, {useState} from 'react'
import Button from '@material-ui/core/Button'
import {AgendaSettings} from 'Event/template/Lefty/Dashboard/Sidebar/SidebarItem/AgendaList'
import {AgendaItemConfig} from 'Event/template/Lefty/Dashboard/Sidebar/SidebarItem/AgendaList/AgendaItemConfig'
import {now} from 'lib/date-time'

export default function AddAgendaButton(props: {
  className?: string
  nextPosition: number
}) {
  const [agenda, setAgenda] = useState<AgendaSettings | null>(null)

  const newAgenda = (): AgendaSettings => ({
    text: 'Event',
    startDate: now(),
    endDate: now(),
    link: null,
    isVisible: true,
  })

  return (
    <>
      <NewAgendaConfig agenda={agenda} onClose={() => setAgenda(null)} />
      <Button
        fullWidth
        size="large"
        variant="contained"
        color="secondary"
        aria-label="add agenda event"
        onClick={() => setAgenda(newAgenda())}
        className={props.className}
      >
        Add Agenda Event
      </Button>
    </>
  )
}

function NewAgendaConfig(props: {
  agenda: AgendaSettings | null
  onClose: () => void
}) {
  const {agenda, onClose} = props
  if (!agenda) {
    return null
  }

  return <AgendaItemConfig onClose={onClose} agenda={agenda} showing />
}
